import axios from '@/functions/axios-instance'

export default {
    name: "auth",
    async logout() {
        try {
            const res = await axios.get( '/auth/signout')
            if (res.data.status === 1) {
                // console.info('auth logout -- remove storage')

               // local storage
                localStorage.removeItem('sessionId')
                localStorage.removeItem('displayName')
                localStorage.removeItem('avatar')
                localStorage.removeItem('role')
                localStorage.removeItem('userIsVerified')
                localStorage.removeItem('userStatus')
                localStorage.removeItem('userExpired')
                localStorage.removeItem('userLastLogin')
                localStorage.removeItem('projectId')
                localStorage.removeItem('projectName')

                localStorage.removeItem('project')
                localStorage.removeItem('entity')
                localStorage.removeItem('entityId')
                localStorage.removeItem('wlId')
                localStorage.removeItem('package')
                localStorage.removeItem('page')
                localStorage.removeItem('totalPage')
                localStorage.removeItem('permission')
                localStorage.removeItem('structure')
                localStorage.removeItem('team')

                // ProjDoc
                localStorage.removeItem('leftDrawer')
                localStorage.removeItem('leftFloatDrawer')

                // View
                localStorage.removeItem('hasClickViewToolbox')
                localStorage.removeItem('leftViewDrawer')
                localStorage.removeItem('leftViewFloatDrawer')

                localStorage.removeItem('signatoryCtrl')
                localStorage.removeItem('signatoryDoc')
                localStorage.removeItem('signatoryDbBoxes')
                localStorage.removeItem('signatorySignee')

                localStorage.removeItem('screenshotUrl')


                return [ '1', 'success']

            } else {
                return ['0', res.data.message]
            }

        } catch (err) {
            // Handle Error Here
            console.info('ERR', err)
            return ['0', err]
        }
    },
    clearStorage() {
        // console.info('----- auth.clearStorage')
        /* localStorage.removeItem('sessionId')
        localStorage.removeItem('userId')
        localStorage.removeItem('displayName')
        localStorage.removeItem('avatar')
        localStorage.removeItem('role')
        localStorage.removeItem('userIsVerified')
        localStorage.removeItem('userStatus')
        localStorage.removeItem('userExpired')
        localStorage.removeItem('userLastLogin')
        localStorage.removeItem('projectId')
        localStorage.removeItem('projectName') */
        localStorage.removeItem('sessionId')
        localStorage.removeItem('displayName')
        localStorage.removeItem('avatar')
        localStorage.removeItem('role')
        localStorage.removeItem('userIsVerified')
        localStorage.removeItem('userStatus')
        localStorage.removeItem('userExpired')
        localStorage.removeItem('userLastLogin')
        localStorage.removeItem('projectId')
        localStorage.removeItem('projectName')
        localStorage.removeItem('package')
        localStorage.removeItem('team')
        localStorage.removeItem('entity')
        localStorage.removeItem('entityId')
        localStorage.removeItem('entityIsVerified')
        localStorage.removeItem('openId')
        localStorage.removeItem('geoInfo')
        localStorage.removeItem('planInfo')
        localStorage.removeItem('permission')
        localStorage.removeItem('structure')

        // ProjDoc
        localStorage.removeItem('leftDrawer')
        localStorage.removeItem('leftFloatDrawer')

        // View
        localStorage.removeItem('hasClickViewToolbox')
        localStorage.removeItem('leftViewDrawer')
        localStorage.removeItem('leftViewFloatDrawer')

        // Signatory
        localStorage.removeItem('hasClickSignatoryToolbox')
        localStorage.removeItem('leftDrawer')
        localStorage.removeItem('signeeClass')
        localStorage.removeItem('signeeId')
        localStorage.removeItem('signeeName')
        localStorage.removeItem('signeeEmail')
        localStorage.removeItem('signee')
        localStorage.removeItem('documentId')
        localStorage.removeItem('documentName')
        localStorage.removeItem('documentUrl')
        localStorage.removeItem('doc')

        // View, ProjDoc, Signatory
        localStorage.removeItem('page')
        localStorage.removeItem('totalPage')
    }
}
